export const SESSION_RECORD = 'SESSION_RECORD';